module.exports = __webpack_public_path__ + "img/img_2.9c67ba4a.png";